import { formatMoney } from "@/utils/fieldValueConverter";

const MoneyField = ({ value }) => {
  const formattedValue = formatMoney(value);

  return formattedValue ? <div>{formattedValue}</div> : null;
};

export default MoneyField;
